import { type CsticId, type LinearSubstep } from "../../models";
import { useSelector } from "react-redux";
import SubstepFrame from "../SubstepFrame";
import { useMinMaxLengthLabel } from "../../hooks/useMinMaxLengthLabel";
import LanguageAwareExternalContent from "../LanguageAwareExternalContent";
import { useTranslation } from "react-i18next";
import { SubstepType } from "~/Configurators/Linear/dtos";
import { FAKE_CSTIC_UNIT_LENGTH } from "~/Configurators/Linear/constants";
import { SimpleCsticNumberField } from "~/Configurators/Shaft/components/SimpleCsticNumberField";
import { selectCsticExpanded } from "~/Configurators/Linear/redux/selectCstic";
import { Alert } from "~/common/m3/Alert/Alert";
import { KmatType } from "~/Configurators/Linear/kmatType";

interface Props {
  csticIndex: number;
  csticAmount: number;
  def: LinearSubstep;
}

const FAKE_LENGTH_CSTIC: CsticId = {
  key: FAKE_CSTIC_UNIT_LENGTH,
  index: 0,
  type: KmatType.Main,
};

const LengthSubstep = ({ def, ...props }: Props) => {
  const { cstic, isDirty, isInConflict } = useSelector(selectCsticExpanded(FAKE_LENGTH_CSTIC, SubstepType.Length));

  const helperLabel = useMinMaxLengthLabel();
  const { t } = useTranslation();

  const isError = isInConflict || (isDirty && !cstic.value);
  const errMsg = isError ? t("linear.step.select.valid.value") : "";

  return (
    <SubstepFrame
      title={def.name}
      description=""
      info={def.info}
      isPicked={def.value !== null}
      showError={isError}
      errorMessage={errMsg}
      {...props}
    >
      <div>
        <div className="scha__linear-configurator__semi-steps__frame__input-block__millimeter-input">
          <SimpleCsticNumberField
            label={def.name}
            csticId={FAKE_LENGTH_CSTIC}
            substepType={SubstepType.Length}
            helperLabel={helperLabel}
            error={isError}
          />
        </div>
        <Alert className="mb-30" severity="info">
          <LanguageAwareExternalContent content={def.footerInfo[0]} loadedClassname={"scha__lc__external-label"} />
        </Alert>
      </div>
    </SubstepFrame>
  );
};
export default LengthSubstep;
